module.exports = __webpack_public_path__ + "static/img/v_5.73f55896.png";